<template lang="pug">
  v-row(no-gutters)
    v-col
      v-textarea(
        solo
        v-model="description"
        label="Опишите недвижимость")
</template>

<script>
export default {
  name: 'Description',
  data: () => ({
    description: ''
  }),
  watch: {
    description(value) {
      this.$emit('set-description', value)
    }
  }
}
</script>
